// Shared wording for FIG-316 UI that waits on backend support. The use case id
// points at .foundry/spec/fig-316/use-cases/.
export function notAvailableYetHint(useCase: string): string {
  return `Not available yet. Needs backend support (${useCase}).`;
}
